import { CourseLayout } from "@/features/training/components/layouts/course-layout"

export function AIHistoryPage() {
  return (
    <CourseLayout className="h-full justify-center">
      <iframe
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
        className="aspect-video w-full"
        src="https://player.vimeo.com/video/1038138324?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        title="AI History"
      />
    </CourseLayout>
  )
}
